import { ActivityMessageData } from '../../api/player/schemas/activity-feed';

export class ActivityEventStack {
  private stack: ActivityMessageData[] = [];

  pushEvents(data: ActivityMessageData[]): void {
    const sortedData = [...data].sort(
      (a, b) => ActivityEventStack.getTimestamp(b) - ActivityEventStack.getTimestamp(a),
    );
    this.stack.push(...sortedData);
  }

  popDueEvents(now: Date): ActivityMessageData[] {
    const nowTimestamp = now.getTime();
    const dueEvents: ActivityMessageData[] = [];

    while (
      this.hasEvents() &&
      ActivityEventStack.getTimestamp(this.stack[this.stack.length - 1]) <= nowTimestamp
    ) {
      const eventDue = this.stack.pop();
      if (eventDue) {
        dueEvents.push(eventDue);
      }
    }
    return dueEvents;
  }

  hasEvents(): boolean {
    return this.stack.length > 0;
  }

  public static getTimestamp(data: ActivityMessageData): number {
    return data.displayedAt ?? data.createdAt;
  }
}
